import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { MedicalDomainTermsQuery } from '@custom/schema';

export const useMedicalDomainTermsQuery = () =>
  useStaticQuery(graphql(MedicalDomainTermsQuery));
